/**
 * Warm White — Flos "Light by category" slider (1:1 measured)
 * flos.com/en/us:
 * - o-container max 1440 / pad 40 (24 <1024)
 * - 3 desktop / 2 tablet / 1 mobile, slideBy = page
 * - gutter 16px (padding-right on slide)
 * - pager "1 - 3 of 6", prev|meta|next
 * - 1px status bar
 * - image 3:4, hover scale 1.05 / 0.4s
 * - CTA "Shop the collection" capitalize
 * Images & titles from Leaves PageFly products; fallback for local static preview.
 */
(function () {
  'use strict';

  if (!document.body || document.documentElement.dataset.leavesWarmFlos === '1') return;
  document.documentElement.dataset.leavesWarmFlos = '1';

  var SECTION_ID = 'leaves-2f81';
  var TITLE_MATCH = /warm\s*white\s*dimming/i;
  var CDN = 'https://cdn.shopify.com/s/files/1/0790/1128/3170/files/';
  var LOCAL = '/assets/warm-flos-fallback/';

  /** Local/static fallback when PageFly Liquid products are not rendered. */
  var FALLBACK_PRODUCTS = [
    {
      title: 'Outdoor ground spike light(color bridge)',
      href: '/products/outdoor-ground-spike-lightcolor-bridge',
      image: LOCAL + '01-spike.jpg',
    },
    {
      title: 'Outdoor ceiling hanging light (color bridge)',
      href: '/products/outdoor-ceiling-hanging-light-color-bridge',
      image: LOCAL + '02-ceiling.jpg',
    },
    {
      title: 'Outdoor mounted hanging light (color bridge)',
      href: '/products/outdoor-mounted-hanging-light-color-bridge',
      image: LOCAL + '03-wall.jpg',
    },
    {
      title: 'Outdoor suspended light (color bridge)',
      href: '/products/outdoor-suspended-light-color-bridge',
      image: CDN + 'c1b9a4618c3ac360b08fd70c1c05b0df.jpg?v=1789111267&width=1200',
    },
    {
      title: 'Outdoor wrap-around light (color bridge)',
      href: '/products/outdoor-wrap-around-light-color-bridge',
      image: CDN + 'f5257a30189475667163fb389f6ff7c9.jpg?v=1789111267&width=1200',
    },
    {
      title: 'Outdoor wall light (color bridge)',
      href: '/products/outdoor-mounted-hanging-light-color-bridge',
      image: CDN + 'cc3a62cd26665d3c67405658cdf3fa09.jpg?v=1784878883&width=1200',
    },
  ];

  function textOf(node) {
    return String((node && node.textContent) || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function hideOriginal(node) {
    if (!node) return;
    node.classList.add('leaves-original-replaced');
    node.setAttribute('aria-hidden', 'true');
    node.setAttribute('hidden', '');
  }

  function findSection() {
    var byId = document.querySelector('#leaves-home [data-section-id="' + SECTION_ID + '"]');
    if (byId) return byId;
    var headings = document.querySelectorAll(
      '#leaves-home [data-leaves-type="FlexSection"] h3, #leaves-home [data-leaves-type="FlexSection"] h2'
    );
    for (var i = 0; i < headings.length; i += 1) {
      if (TITLE_MATCH.test(textOf(headings[i]))) {
        return headings[i].closest('[data-leaves-type="FlexSection"]');
      }
    }
    return document.querySelector('[data-section-id="' + SECTION_ID + '"]');
  }

  var REMOVED_COPY = /two sets of lighting fixtures|three sets of lighting fixtures|2套灯具组合|户外定制灯具/i;
  var REMOVED_IDS = { 'leaves-fa95': 1, 'leaves-b3c6': 1 };

  function removeFixtureSets() {
    var nodes = document.querySelectorAll('#leaves-home [data-leaves-type="FlexSection"]');
    Array.prototype.forEach.call(nodes, function (section) {
      var id = section.getAttribute('data-section-id') || '';
      if (id === SECTION_ID || section.classList.contains('leaves-warm-flos-host')) return;
      if (TITLE_MATCH.test(textOf(section))) return;
      if (REMOVED_IDS[id] || REMOVED_COPY.test(textOf(section))) {
        if (section.parentNode) section.parentNode.removeChild(section);
      }
    });
  }

  function findHero() {
    return (
      document.querySelector('#leaves-home [data-section-id="leaves-74fc"]') ||
      (document.querySelector('#leaves-home [data-leaves-type="Slideshow"]') &&
        document.querySelector('#leaves-home [data-leaves-type="Slideshow"]').closest('[data-leaves-type="FlexSection"]'))
    );
  }

  function placeUnderHero(section) {
    var hero = findHero();
    if (!hero || !section || !hero.parentNode || hero === section) return false;
    var band = document.querySelector('.leaves-typo-band');
    var anchor = hero;
    if (band && band.parentNode === hero.parentNode) {
      if (band.previousElementSibling !== hero) {
        hero.parentNode.insertBefore(band, hero.nextSibling);
      }
      anchor = band;
    }
    if (section.previousElementSibling !== anchor) {
      anchor.parentNode.insertBefore(section, anchor.nextSibling);
    }
    return section.previousElementSibling === anchor;
  }

  window.leavesPinWarmBelowPatio = function () {
    removeFixtureSets();
    var section = findSection();
    if (section) placeUnderHero(section);
  };

  function resolveHref(slide) {
    var link =
      slide.querySelector('a[data-leaves-type="ProductViewDetails2"]') ||
      slide.querySelector('a[href*="/products/"]') ||
      slide.querySelector('[data-href]');
    if (!link) return '';
    return link.getAttribute('href') || link.getAttribute('data-href') || '';
  }

  function resolveTitle(slide, img) {
    var titleNode = slide.querySelector(
      '[data-leaves-type="ProductTitle"], [data-product-type="title"], h3, h4'
    );
    var title = textOf(titleNode);
    if (title && title.indexOf('{{') === -1) return title;
    if (img) {
      title = (img.getAttribute('alt') || '')
        .replace(/__PID:.*$/i, '')
        .replace(/\.(jpg|png|webp)$/i, '')
        .trim();
    }
    return title || 'View product';
  }

  function resolveImage(slide) {
    var img =
      slide.querySelector('.leaves-main-media img.active') ||
      slide.querySelector('.leaves-main-media img') ||
      slide.querySelector('img');
    if (!img) return null;
    var src = img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '';
    if (!src || src.indexOf('{{') !== -1) return null;
    if (/^https?:\/\/127\.0\.0\.1|^https?:\/\/localhost|\/demos\//i.test(src)) return null;
    return { img: img, src: src };
  }

  function collectProducts(section) {
    var list = section.querySelector('[data-leaves-type="ProductList2"]');
    if (!list) return [];
    var slides = list.querySelectorAll('.leaves-slide');
    var products = [];
    var seen = {};
    Array.prototype.forEach.call(slides, function (slide) {
      if (slide.closest('[data-leaves-type="MediaList2"]')) return;
      if (slide.classList.contains('leaves-slide-list-media')) return;
      var media = resolveImage(slide);
      if (!media) return;
      var href = resolveHref(slide);
      if (!href || href.indexOf('{{') !== -1) return;
      var title = resolveTitle(slide, media.img);
      var key = href + '|' + title;
      if (seen[key]) return;
      seen[key] = true;
      products.push({ title: title, href: href, image: media.src });
    });
    return products;
  }

  function perPage() {
    var w = window.innerWidth || document.documentElement.clientWidth;
    if (w < 768) return 1;
    return 4;
  }

  function sceneProducts() {
    var presets = window.LEAVES_SCENE_PRESETS || [];
    var images = window.LEAVES_SCENE_IMAGES || {};
    if (!presets.length) return [];
    return presets.map(function (preset) {
      return {
        title: preset.title,
        href: '/pages/configure-v2?preset=' + encodeURIComponent(preset.id),
        image: images[preset.id] || '',
        presetId: preset.id,
      };
    });
  }

  function slideHtml(p) {
    return (
      '<div class="leaves-warm-flos__slide">' +
      '<article class="leaves-warm-flos__card">' +
      '<a class="leaves-warm-flos__media" href="' +
      escapeAttr(p.href) +
      '"' +
      (p.presetId ? ' data-preset="' + escapeAttr(p.presetId) + '"' : '') +
      '>' +
      '<img src="' +
      escapeAttr(p.image) +
      '" alt="' +
      escapeAttr(p.title) +
      '" loading="lazy" decoding="async" draggable="false">' +
      '</a>' +
      '<div class="leaves-warm-flos__body">' +
      '<div class="leaves-warm-flos__copy">' +
      '<h3 class="leaves-warm-flos__name"><a href="' +
      escapeAttr(p.href) +
      '">' +
      escapeHtml(p.title) +
      '</a></h3>' +
      '<span class="leaves-warm-flos__price" data-preset-price="' +
      escapeAttr(p.presetId || '') +
      '">…</span></div>' +
      '<div class="leaves-warm-flos__actions">' +
      '<button type="button" class="leaves-warm-flos__add" data-preset-add="' +
      escapeAttr(p.presetId || '') +
      '" data-label="Add to cart">Add to cart</button>' +
      '<a class="leaves-warm-flos__customize" href="' +
      escapeAttr(p.href) +
      '">Customize this Kit</a></div></div></article></div>'
    );
  }

  function fillPrices(root) {
    var pricing = window.LEAVES_CONFIGURATOR_PRICING;
    var core = window.LEAVES_CONFIGURATOR_CORE;
    var rules = window.LEAVES_CONFIGURATOR_RULES;
    var presets = window.LEAVES_SCENE_PRESETS || [];
    if (!root || !pricing || !core || !rules || !presets.length) return;
    var catalog = pricing.emptyCatalog();
    catalog.moneyFormat = window.LEAVES_MONEY_FORMAT || '€{{amount}}';
    pricing.loadCatalog(rules, { catalog: catalog }).then(function () {
      presets.forEach(function (preset) {
        var el = root.querySelector('[data-preset-price="' + preset.id + '"]');
        if (!el) return;
        var state = core.createState();
        if (!core.applyEditableState(state, preset.state)) return;
        var quote = core.buildPriceQuote(rules, state, catalog);
        // Show shop money format (€…) whenever the quote has a total.
        // Do not hide on "unavailable" — catalog still returns EUR prices.
        el.textContent =
          quote && quote.catalogLoaded && quote.totalMoney && !(quote.missing && quote.missing.length)
            ? quote.totalMoney
            : '…';
      });
    });
  }

  function presetById(id) {
    var presets = window.LEAVES_SCENE_PRESETS || [];
    for (var i = 0; i < presets.length; i += 1) {
      if (presets[i].id === id) return presets[i];
    }
    return null;
  }

  function bindCart(root) {
    if (root.getAttribute('data-cart-bound') === '1') return;
    root.setAttribute('data-cart-bound', '1');

    function paintButton(btn, text) {
      if (btn.classList.contains('leaves-warm-flos__bag')) {
        btn.setAttribute('aria-label', text);
        btn.classList.toggle('is-added', text === 'Added');
        btn.classList.toggle('is-adding', text.indexOf('Adding') === 0);
        return;
      }
      btn.textContent = text;
    }

    function resetAddingButtons() {
      var buttons = root.querySelectorAll('[data-preset-add]');
      Array.prototype.forEach.call(buttons, function (btn) {
        btn._addRequest = 0;
        var adding = btn.classList.contains('is-adding') || btn.textContent.indexOf('Adding') === 0;
        if (!btn.disabled && !adding) return;
        btn.disabled = false;
        paintButton(btn, btn.getAttribute('data-label') || 'Add to cart');
      });
    }

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      resetAddingButtons();
    });

    root.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-preset-add]');
      if (!btn || !root.contains(btn)) return;
      event.preventDefault();
      if (btn.disabled) return;
      var preset = presetById(btn.getAttribute('data-preset-add'));
      var pricing = window.LEAVES_CONFIGURATOR_PRICING;
      var core = window.LEAVES_CONFIGURATOR_CORE;
      var rules = window.LEAVES_CONFIGURATOR_RULES;
      if (!preset || !pricing || !core || !rules) {
        paintButton(btn, 'Unavailable');
        return;
      }
      var label = btn.getAttribute('data-label') || 'Add to cart';
      btn.setAttribute('data-label', label);
      var requestId = (btn._addRequest || 0) + 1;
      btn._addRequest = requestId;
      btn.disabled = true;
      paintButton(btn, 'Adding…');
      var catalog = pricing.emptyCatalog();
      catalog.moneyFormat = window.LEAVES_MONEY_FORMAT || '€{{amount}}';
      pricing
        .loadCatalog(rules, { catalog: catalog })
        .then(function () {
          if (btn._addRequest !== requestId) return null;
          var state = core.createState();
          if (!core.applyEditableState(state, preset.state)) {
            throw new Error('This configuration could not be prepared.');
          }
          var result = core.buildCartItems(rules, state, catalog);
          if (!result.valid) {
            throw new Error((result.errors && result.errors[0]) || 'This configuration is not ready.');
          }
          var images = window.LEAVES_SCENE_IMAGES || {};
          var items = (result.items || []).map(function (item) {
            var safeItem = {
              id: item.id,
              quantity: item.quantity,
              properties: item.properties || {},
            };
            if (!item.parent_id) {
              safeItem.properties._leavesTitle = preset.title;
              if (images[preset.id]) safeItem.properties._leavesImage = images[preset.id];
            }
            if (item.parent_id) safeItem.parent_id = item.parent_id;
            return safeItem;
          });
          var sectionIds = [];
          document.querySelectorAll('cart-items-component').forEach(function (item) {
            var sectionId = item.getAttribute('data-section-id');
            if (sectionId) sectionIds.push(sectionId);
          });
          var body = { items: items };
          if (sectionIds.length) {
            body.sections = sectionIds.join(',');
            body.sections_url = window.location.pathname;
          }
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          }).then(function (response) {
            return response.text().then(function (raw) {
              if (!response.ok) {
                var payload = null;
                try {
                  payload = raw ? JSON.parse(raw) : null;
                } catch (err) {
                  payload = null;
                }
                throw new Error(
                  (payload && (payload.description || payload.message)) || 'The cart could not accept this configuration.'
                );
              }
              var added = null;
              try {
                added = raw ? JSON.parse(raw) : null;
              } catch (err2) {
                added = null;
              }
              return { sections: added && added.sections };
            });
          });
        })
        .then(function (result) {
          if (btn._addRequest !== requestId) return;
          if (result === null) return;
          btn.disabled = false;
          paintButton(btn, 'Added');
          window.setTimeout(function () {
            if (btn._addRequest !== requestId) return;
            if (btn.getAttribute('aria-label') === 'Added' || btn.textContent === 'Added') {
              paintButton(btn, label);
            }
          }, 1600);
          return fetch('/cart.js', { headers: { Accept: 'application/json' } })
            .then(function (response) {
              return response.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
                      sections: result.sections,
                      source: 'leaves-kit',
                    },
                  },
                })
              );
            })
            .catch(function () {});
        })
        .catch(function (err) {
          if (btn._addRequest !== requestId) return;
          btn.disabled = false;
          paintButton(btn, label);
          btn.setAttribute('title', err && err.message ? err.message : 'Could not add to cart');
        });
    });
  }

  function wireIntroReveal(root) {
    if (!root || root.getAttribute('data-reveal') === '1') return;
    var trigger = root.querySelector('.leaves-warm-flos__intro') || root;
    var bits = trigger.querySelectorAll('.leaves-warm-flos__reveal-off');
    if (!bits.length) return;
    root.setAttribute('data-reveal', '1');

    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      Array.prototype.forEach.call(bits, function (el) {
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
      return;
    }

    var RISE = 48;
    var TWEEN = 0.5;
    var STAGGER = 0.1;
    var n = bits.length;
    var total = TWEEN + STAGGER * Math.max(0, n - 1);
    var shown = 0;
    var last = 0;
    var running = false;

    function rawProgress() {
      var rect = trigger.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      var startTop = vh * 0.98;
      var endTop = vh * 0.36;
      var p = (startTop - rect.top) / Math.max(1, startTop - endTop);
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      return p;
    }

    function apply(progress) {
      var time = progress * total;
      var i;
      for (i = 0; i < n; i += 1) {
        var local = (time - i * STAGGER) / TWEEN;
        if (local < 0) local = 0;
        if (local > 1) local = 1;
        var eased = 1 - (1 - local) * (1 - local);
        bits[i].style.opacity = String(eased);
        bits[i].style.transform = 'translate3d(0,' + (RISE * (1 - eased)).toFixed(2) + 'px,0)';
      }
    }

    var done = false;

    function finish() {
      if (done) return;
      done = true;
      apply(1);
      window.removeEventListener('scroll', kick);
      window.removeEventListener('resize', kick);
    }

    function frame(now) {
      if (done) return;
      if (!last) last = now;
      var dt = Math.min(0.05, (now - last) / 1000);
      last = now;
      var target = rawProgress();
      if (target < shown) target = shown;
      shown += (target - shown) * (1 - Math.exp(-dt / 0.16));
      if (Math.abs(target - shown) < 0.004) shown = target;
      if (shown > 1) shown = 1;
      apply(shown);
      if (shown >= 1) {
        finish();
        running = false;
        return;
      }
      if (shown !== target) {
        window.requestAnimationFrame(frame);
      } else {
        running = false;
        last = 0;
      }
    }

    function kick() {
      if (done || running) return;
      running = true;
      last = 0;
      window.requestAnimationFrame(frame);
    }

    window.addEventListener('scroll', kick, { passive: true });
    window.addEventListener('resize', kick);
    kick();
  }

  function build(section, products) {
    if (section.querySelector('.leaves-warm-flos')) return;

    var flex = section.querySelector('.leaves-flex-section') || section;
    var headings = flex.querySelectorAll(
      ':scope > h3, :scope > h2, :scope > [data-leaves-type="Heading2"]'
    );
    var leadNode = flex.querySelector(':scope > p, :scope > [data-leaves-type="Paragraph4"]');
    var list = flex.querySelector('[data-leaves-type="ProductList2"]');
    var moreBtn = flex.querySelector(':scope > a[data-leaves-type="Button2"]');

    var mainTitle = 'Bestselling kits';
    var lead = 'Our most popular kits. Add to cart to buy, or click in to keep customizing.';

    var root = document.createElement('div');
    root.className = 'leaves-warm-flos';
    root.setAttribute('data-leaves-warm-flos', '');
    root.setAttribute('role', 'region');
    root.setAttribute('aria-roledescription', 'carousel');
    root.setAttribute('aria-label', mainTitle);

    root.innerHTML =
      '<header class="leaves-warm-flos__intro">' +
      '<h2 class="leaves-warm-flos__title">' +
      escapeHtml(mainTitle) +
      '</h2>' +
      '<a class="leaves-warm-flos__shop" href="/pages/configure-v2">Build your kit</a>' +
      '<p class="leaves-warm-flos__lead">' +
      escapeHtml(lead) +
      '</p></header>' +
      '<div class="leaves-warm-flos__stage">' +
      '<div class="leaves-warm-flos__viewport">' +
      '<div class="leaves-warm-flos__track">' +
      products.map(slideHtml).join('') +
      '</div></div>' +
      '<div class="leaves-warm-flos__controls">' +
      '<div class="leaves-warm-flos__progress leaves-warm-flos__status-indicator" aria-hidden="true"></div>' +
      '<div class="leaves-warm-flos__arrows">' +
      '<button type="button" class="leaves-warm-flos__btn leaves-warm-flos__btn--prev" aria-label="Previous">' +
      '<svg width="14" height="22" viewBox="0 0 14 22" fill="none" aria-hidden="true"><path d="M12 2 3 11l9 9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button>' +
      '<button type="button" class="leaves-warm-flos__btn leaves-warm-flos__btn--next" aria-label="Next">' +
      '<svg width="14" height="22" viewBox="0 0 14 22" fill="none" aria-hidden="true"><path d="M2 2l9 9-9 9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</button></div></div></div>';

    Array.prototype.forEach.call(headings, hideOriginal);
    hideOriginal(leadNode);
    hideOriginal(list);
    hideOriginal(moreBtn);

    if (list && list.parentNode) list.parentNode.insertBefore(root, list);
    else flex.appendChild(root);

    section.classList.add('leaves-warm-flos-host');
    bindSlider(root, products.length);
    fillPrices(root);
    bindCart(root);
    wireIntroReveal(root);
  }

  function bindSlider(root, total) {
    var viewport = root.querySelector('.leaves-warm-flos__viewport');
    var track = root.querySelector('.leaves-warm-flos__track');
    var slides = root.querySelectorAll('.leaves-warm-flos__slide');
    var meta = root.querySelector('.leaves-warm-flos__meta');
    var indicator = root.querySelector('.leaves-warm-flos__status-indicator');
    var prevBtn = root.querySelector('.leaves-warm-flos__btn--prev');
    var nextBtn = root.querySelector('.leaves-warm-flos__btn--next');
    var page = 0;
    var pp = 3;
    var slideW = 0;
    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function maxPage() {
      return Math.max(0, Math.ceil(total / pp) - 1);
    }

    function measure() {
      pp = perPage();
      var vw = viewport.getBoundingClientRect().width;
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
      if (!isFinite(gap)) gap = 0;
      slideW = (vw - gap * Math.max(0, pp - 1)) / pp;
      Array.prototype.forEach.call(slides, function (slide) {
        slide.style.width = slideW + 'px';
      });
    }

    function offsetForPage(p) {
      var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
      if (!isFinite(gap)) gap = 0;
      return -(p * pp * (slideW + gap));
    }

    function updateStatus() {
      var start = page * pp + 1;
      var end = Math.min(total, (page + 1) * pp);
      if (meta) meta.textContent = start + ' - ' + end + ' of ' + total;

      if (indicator) {
        var pages = maxPage() + 1;
        var widthPct = 100 / pages;
        indicator.style.width = widthPct + '%';
        indicator.style.transform = 'translateX(' + page * 100 + '%)';
      }

      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= maxPage();
    }

    function goTo(nextPage, animate) {
      var max = maxPage();
      if (nextPage < 0) nextPage = 0;
      else if (nextPage > max) nextPage = max;
      page = nextPage;

      if (animate === false || reduced) {
        track.style.transition = 'none';
      } else {
        track.style.transition = '';
      }

      track.style.transform = 'translate3d(' + offsetForPage(page) + 'px,0,0)';
      updateStatus();

      if (animate === false) {
        void track.offsetHeight;
        track.style.transition = '';
      }
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goTo(page - 1, true);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goTo(page + 1, true);
      });
    }

    var touching = false;
    var startX = 0;
    var startTX = 0;

    viewport.addEventListener(
      'pointerdown',
      function (e) {
        if (e.button != null && e.button !== 0) return;
        if (e.target.closest('a, button')) return;
        touching = true;
        startX = e.clientX;
        startTX = offsetForPage(page);
        track.style.transition = 'none';
        try {
          viewport.setPointerCapture(e.pointerId);
        } catch (err) {}
      },
      { passive: true }
    );

    viewport.addEventListener('pointermove', function (e) {
      if (!touching) return;
      var dx = e.clientX - startX;
      track.style.transform = 'translate3d(' + (startTX + dx) + 'px,0,0)';
    });

    viewport.addEventListener('pointerup', function (e) {
      if (!touching) return;
      touching = false;
      var dx = e.clientX - startX;
      track.style.transition = '';
      if (Math.abs(dx) > 48) goTo(dx < 0 ? page + 1 : page - 1, true);
      else goTo(page, true);
    });

    window.addEventListener(
      'resize',
      function () {
        measure();
        goTo(Math.min(page, maxPage()), false);
      },
      { passive: true }
    );

    measure();
    goTo(0, false);
  }

  function run() {
    removeFixtureSets();
    var section = findSection();
    if (!section) return false;
    placeUnderHero(section);
    if (!section.querySelector('.leaves-warm-flos')) {
      var products = sceneProducts();
      if (!products.length) products = collectProducts(section);
      if (!products.length) products = FALLBACK_PRODUCTS.slice();
      if (!products.length) return false;
      build(section, products);
    }
    var hero = findHero();
    var band = document.querySelector('.leaves-typo-band');
    var anchor = band && hero && band.parentNode === hero.parentNode ? band : hero;
    return !!(anchor && section.previousElementSibling === anchor);
  }

  var booted = false;

  function boot() {
    if (booted) return;
    booted = true;
    run();
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var placed = run();
      if ((placed && tries > 8) || tries > 40) window.clearInterval(timer);
    }, 80);
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        run();
      });
      mo.observe(document.documentElement, { childList: true, subtree: true });
      window.setTimeout(function () {
        mo.disconnect();
      }, 8000);
    }
  }

  if (document.readyState === 'loading') {
    if (document.body) boot();
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
